import { render, staticRenderFns } from "./ComposicaoDoRebanhoMedioPorCabecaPercentual.vue?vue&type=template&id=72ac5cbe&scoped=true&"
import script from "./ComposicaoDoRebanhoMedioPorCabecaPercentual.vue?vue&type=script&lang=js&"
export * from "./ComposicaoDoRebanhoMedioPorCabecaPercentual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ac5cbe",
  null
  
)

export default component.exports